import { SavedCard } from '@dataTypes/payment.types'

export type { SavedCard }

export type MockSavedPaymentMethod = SavedCard & {
  methodType?: 'card' | 'bank'
  displayLabel?: string
  bankName?: string
}

export type PaymentMethodType = 'Cash' | 'Credit Card' | 'Bank'

export type PaymentStatus = 'Complete' | 'Follow-up' | 'Pending' | 'Cancelled'

export interface PaymentItem {
  code: string
  doctor: string
  date: string
  amount: number
  status: PaymentStatus
  payment_method: PaymentMethodType
}

export interface PaymentMonthData {
  month: string
  items: PaymentItem[]
}

export interface OutstandingBalance {
  current: number
  total: number
  insuranceCoverage: {
    used: number
    total: number
  }
  patientBalance: number
  familyBalance: number
  discountApplied: number
  walletBalance: number
}

export interface PaymentData {
  outstandingBalance: OutstandingBalance
  savedCards: MockSavedPaymentMethod[]
  paymentHistory: PaymentMonthData[]
}

export const mockPaymentData: Record<string, PaymentData> = {
  'mock-patient-1': {
    outstandingBalance: {
      current: 2900,
      total: 3000,
      insuranceCoverage: {
        used: 1200,
        total: 3000,
      },
      patientBalance: 300,
      familyBalance: 1400,
      discountApplied: 500,
      walletBalance: 100,
    },
    savedCards: [
      {
        brand: 'mastercard',
        lastFour: '4745',
        expiryMonth: '03',
        expiryYear: '2029',
        isDefault: true,
        methodType: 'card',
        displayLabel: 'Debit/credit card',
      },
      {
        brand: 'unknown',
        lastFour: '9374',
        expiryMonth: '01',
        expiryYear: '2030',
        isDefault: false,
        methodType: 'bank',
        displayLabel: 'Digital bank/wallet',
        bankName: 'Bank of America',
      },
    ],
    paymentHistory: [
      {
        month: 'January 2025',
        items: [],
      },
      {
        month: 'December 2024',
        items: [
          {
            code: 'D2544',
            doctor: 'Dr. Nguyen',
            date: '12-10-2024',
            amount: 300.0,
            status: 'Complete',
            payment_method: 'Credit Card',
          },
          {
            code: 'D0150',
            doctor: 'Dr. Nguyen',
            date: '12-10-2024',
            amount: 200.0,
            status: 'Pending',
            payment_method: 'Credit Card',
          },
        ],
      },
      {
        month: 'November 2024',
        items: [
          {
            code: 'D2391',
            doctor: 'Dr. Nguyen',
            date: '11-23-2024',
            amount: 300.0,
            status: 'Complete',
            payment_method: 'Cash',
          },
        ],
      },
      {
        month: 'October 2024',
        items: [
          {
            code: 'D1110',
            doctor: 'Dr. Johnson',
            date: '10-15-2024',
            amount: 150.0,
            status: 'Complete',
            payment_method: 'Credit Card',
          },
        ],
      },
      {
        month: 'September 2024',
        items: [],
      },
    ],
  },
  'mock-patient-2': {
    outstandingBalance: {
      current: 1500,
      total: 2000,
      insuranceCoverage: {
        used: 800,
        total: 2000,
      },
      patientBalance: 200,
      familyBalance: 500,
      discountApplied: 300,
      walletBalance: 50,
    },
    savedCards: [
      {
        brand: 'visa',
        lastFour: '1234',
        expiryMonth: '12',
        expiryYear: '2026',
        isDefault: true,
        methodType: 'card',
        displayLabel: 'Debit/credit card',
      },
      {
        brand: 'unknown',
        lastFour: '5678',
        expiryMonth: '06',
        expiryYear: '2025',
        isDefault: false,
        methodType: 'bank',
        displayLabel: 'Digital bank/wallet',
        bankName: 'Chase Bank',
      },
    ],
    paymentHistory: [
      {
        month: 'January 2025',
        items: [],
      },
      {
        month: 'December 2024',
        items: [
          {
            code: 'D0150',
            doctor: 'Dr. Rodriguez',
            date: '12-20-2024',
            amount: 180.0,
            status: 'Complete',
            payment_method: 'Credit Card',
          },
          {
            code: 'D2391',
            doctor: 'Dr. Rodriguez',
            date: '12-10-2024',
            amount: 220.0,
            status: 'Complete',
            payment_method: 'Bank',
          },
        ],
      },
      {
        month: 'November 2024',
        items: [
          {
            code: 'D1110',
            doctor: 'Dr. Rodriguez',
            date: '11-18-2024',
            amount: 150.0,
            status: 'Complete',
            payment_method: 'Cash',
          },
        ],
      },
    ],
  },
}
